import styled from 'styled-components';

export const EventPlayersFieldStyled = styled.div`
  .titles-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(var(--apx) * 10);

    .total-label {
      font-family: 'DINNextLTPro-Heavy';
      text-transform: uppercase;
      position: relative;
      top: calc(var(--apx) * 2);
      margin-right: 0.2em;
      margin-left: auto;
    }

    .total-value {
      height: calc(var(--apx) * 40);
      width: calc(var(--apx) * 65);
      border-radius: 5px;
      background-color: var(--greydd);
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: calc(var(--apx) * 5);
    }
  }

  .checkbox-wrapper {
    flex: none;
    text-align: center;
    width: calc(var(--apx) * 60);
    & > span {
      padding: 0;
    }
  }

  .mini-tag {
    height: calc(var(--apx) * 30);
    width: calc(var(--apx) * 60);
    border-radius: calc(var(--apx) * 5);
    background-color: var(--grey9b);
    color: white;
    font-family: 'DINNextLTPro-Bold';
    font-size: calc(var(--apx) * 16);
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
